var Backbone, SharedSpinnerTemplate, SharedSpinnerView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedSpinnerTemplate = require('../../spinner.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SharedSpinnerView = (function(superClass) {
  extend(SharedSpinnerView, superClass);

  function SharedSpinnerView() {
    return SharedSpinnerView.__super__.constructor.apply(this, arguments);
  }

  SharedSpinnerView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedSpinnerTemplate;
  };

  SharedSpinnerView.prototype.show = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$el.html(toHtml(this.template, hash, this.I18nScope));
      if (hash.append) {
        this.$container.append(this.$el);
      } else {
        this.$container.html(this.$el);
      }
      if (hash.height) {
        this.$el.css('height', hash.height);
        $('.g-spinner', this.$el).css('height', hash.height);
      }
      if (hash.id) {
        return this.$el.attr('id', hash.id);
      }
    }
  };

  SharedSpinnerView.prototype.hide = function() {
    return this.$el.empty();
  };

  SharedSpinnerView.prototype.remove = function() {
    return this.$el.remove();
  };

  return SharedSpinnerView;

})(Backbone.View);

module.exports = SharedSpinnerView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc2hhcmVkL2Zyb250ZW5kL3ZpZXdzL3NwaW5uZXJfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9zaGFyZWQvZnJvbnRlbmQvdmlld3Mvc3Bpbm5lcl92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGtEQUFBO0VBQUE7OztBQUFBLHFCQUFBLEdBQXdCLE9BQUEsQ0FBUSw2QkFBUjs7QUFDeEIsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7OEJBRUosVUFBQSxHQUFhLFNBQUE7SUFDWCxJQUFDLENBQUEsU0FBRCxHQUFhO1dBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtFQUZEOzs4QkFJYixJQUFBLEdBQU8sU0FBQyxJQUFEO0lBQ0wsSUFBRyxnREFBSDtNQUNFLElBQUMsQ0FBQSxVQUFELEdBQWMsSUFBSSxDQUFDO01BQ25CLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFsQixFQUF3QixJQUFDLENBQUEsU0FBekIsQ0FBVjtNQUVBLElBQUcsSUFBSSxDQUFDLE1BQVI7UUFDRSxJQUFDLENBQUEsVUFBVSxDQUFDLE1BQVosQ0FBbUIsSUFBQyxDQUFBLEdBQXBCLEVBREY7T0FBQSxNQUFBO1FBR0UsSUFBQyxDQUFBLFVBQVUsQ0FBQyxJQUFaLENBQWlCLElBQUMsQ0FBQSxHQUFsQixFQUhGOztNQUtBLElBQUcsSUFBSSxDQUFDLE1BQVI7UUFDRSxJQUFDLENBQUEsR0FBRyxDQUFDLEdBQUwsQ0FBUyxRQUFULEVBQW1CLElBQUksQ0FBQyxNQUF4QjtRQUNBLENBQUEsQ0FBRSxZQUFGLEVBQWdCLElBQUMsQ0FBQSxHQUFqQixDQUFxQixDQUFDLEdBQXRCLENBQTBCLFFBQTFCLEVBQW9DLElBQUksQ0FBQyxNQUF6QyxFQUZGOztNQUdBLElBQUcsSUFBSSxDQUFDLEVBQVI7ZUFDRSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxJQUFWLEVBQWdCLElBQUksQ0FBQyxFQUFyQixFQURGO09BWkY7O0VBREs7OzhCQWlCUCxJQUFBLEdBQU8sU0FBQTtXQUNMLElBQUMsQ0FBQSxHQUFHLENBQUMsS0FBTCxDQUFBO0VBREs7OzhCQUdQLE1BQUEsR0FBUyxTQUFBO1dBQ1AsSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQUE7RUFETzs7OztHQTFCcUIsUUFBUSxDQUFDOztBQTZCekMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
